<template>
    <DModal
        :title="__('customers.customers.issue_a_refund')"
        :show="showModal"
        is-confirm
        is-error
        is-awaiting-validation
        @confirm="confirm"
        @close="close"
    >
        <div class="p-4">
            <DRow>
                <DCol>
                    <DInput
                        id="amount"
                        v-model="form.amount"
                        :label="__('customers.customers.amount')"
                        add-label-classes="required"
                        type="number"
                        min="0"
                        :max="maxRefundAmount"
                    />
                    <p
                        v-if="errors.amount"
                        class="help-block text-danger"
                    >
                        {{ errors.amount }}
                    </p>
                    <p
                        v-if="refundLimitHint"
                        class="help-block hint"
                    >
                        {{ refundLimitHint }}
                    </p>
                </DCol>
            </DRow>
            <DRow>
                <DCol>
                    <DSelect
                        id="account"
                        v-model="form.account"
                        :label="__('customers.customers.account')"
                        :options="refundAccountOptions"
                        add-label-classes="required"
                        @update:value="handleAccountChange"
                    />
                    <p
                        v-if="errors.account"
                        class="help-block text-danger"
                    >
                        {{ errors.account }}
                    </p>
                </DCol>
            </DRow>
            <DRow>
                <DCol>
                    <DInput
                        id="iban"
                        v-model="form.iban"
                        :label="__('customers.customers.iban')"
                        add-label-classes="required"
                    />
                    <p
                        v-if="errors.iban"
                        class="help-block text-danger"
                    >
                        {{ errors.iban }}
                    </p>
                </DCol>
            </DRow>
            <DRow>
                <DCol>
                    <DInput
                        id="bic"
                        v-model="form.bic"
                        :label="__('customers.customers.bic')"
                    />
                    <p
                        v-if="errors.bic"
                        class="help-block text-danger"
                    >
                        {{ errors.bic }}
                    </p>
                </DCol>
            </DRow>
            <DRow>
                <DCol>
                    <DInput
                        id="account_owner"
                        v-model="form.account_owner"
                        :label="__('customers.customers.bank_account_bearer')"
                        add-label-classes="required"
                    />
                    <p
                        v-if="errors.account_owner"
                        class="help-block text-danger"
                    >
                        {{ errors.account_owner }}
                    </p>
                </DCol>
            </DRow>
            <DRow>
                <DCol>
                    <DFormTextarea
                        v-model="form.activity_log_comment"
                        class="change-reason change-reason-modal"
                        :placeholder="__('messages.refund_reason')"
                        :label="__('messages.refund_reason')"
                        maxlength="1000"
                    />
                    <p
                        v-if="errors.activity_log_comment"
                        class="help-block text-danger"
                    >
                        {{ errors.activity_log_comment }}
                    </p>
                </DCol>
            </DRow>
            <p
                v-if="errors.message"
                class="help-block text-danger"
            >
                {{ errors.message }}
            </p>
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'RefundModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        creditBalance: {
            type: Number,
            default: () => { return 0.00 }
        },
        refundLimit: {
            type: Number,
            default: () => { return 0.00 }
        }
    },
    emits: ['confirm', 'close-modal'],
    data () {
        return {
            form: this.$inertia.form({
                amount: 0,
                account: null,
                iban: null,
                bic: null,
                account_owner: null,
                activity_log_comment: ''
            })
        }
    },
    computed: {
        errors () {
            return this.$page.props.errors
        },
        maxRefundAmount () {
            return Math.min(this.refundLimit, this.creditBalance)
        },
        refundAccountOptions () {
            const options = []

            if (this.customer.active_sepa_mandate?.id) {
                options.push({
                    label: this.__('customers.customers.saved_account'),
                    value: this.customer.active_sepa_mandate.id
                })
            }

            options.push({
                label: this.__('customers.customers.other_account'),
                value: ''
            })

            return options
        },
        refundLimitHint () {
            const permissions = this.$page.props.auth.permissions
            if (permissions.includes('credit_balance.refund_unlimited')) {
                return ''
            }
            if (this.creditBalance <= this.refundLimit) {
                return ''
            }

            return this.__('customers.invoices.refund_limit_help')
        }
    },
    created () {
        if (this.customer.active_sepa_mandate) {
            this.handleAccountChange(this.customer.active_sepa_mandate.id)
        }
        this.form.amount = this.maxRefundAmount
    },
    methods: {
        handleAccountChange (value) {
            if (value === this.customer.active_sepa_mandate.id) {
                this.form.iban = this.customer.active_sepa_mandate.iban
                this.form.bic = this.customer.active_sepa_mandate.bic
                this.form.account_owner = this.customer.active_sepa_mandate.account_owner

                return
            }

            this.form.iban = null
            this.form.bic = null
            this.form.account_owner = null
        },
        confirm () {
            this.$emit('confirm', this.form)
        },
        close () {
            this.$emit('close-modal')
        }
    }
}
</script>

<style>
.hint {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
}
</style>
